export class ForgotPasswordTo {
  public Email: string;
}
